import { css, styled } from "@mui/material";

import { cssForHeaderWithLinearGradient, cssPropertiesToString } from "@utils";

export const MDXStyles = styled("div")(
  ({ theme }) => css`
    // margins --->
    h2,
    & > p,
    ul,
    ol {
      ${theme.breakpoints.up("mobile")} {
        margin-left: 16px;
        margin-right: 16px;
      }

      ${theme.breakpoints.up("tablet")} {
        margin-left: 64px;
        margin-right: 64px;
      }

      ${theme.breakpoints.up("desktop")} {
        margin-left: 110px;
        margin-right: 110px;
      }

      ${theme.breakpoints.up("desktopXl")} {
        margin-left: 220px;
        margin-right: 220px;
      }
    }

    p,
    ul,
    ol {
      margin-bottom: 16px;
    }

    li {
      margin-bottom: 4px;
    }

    p + ol,
    p + ul {
      margin-top: -8px;
    }

    h2 {
      ${theme.breakpoints.up("mobile")} {
        margin-top: 24px;
        margin-bottom: 8px;
      }

      ${theme.breakpoints.up("tablet")} {
        margin-bottom: 16px;
      }

      ${theme.breakpoints.up("desktop")} {
        margin-top: 32px;
      }
    }

    h2:first-of-type {
      margin-top: 48px;
    }

    & > p:last-of-type {
      margin-bottom: 48px;
    }
    // <--- margins

    h2 {
      ${cssForHeaderWithLinearGradient(theme)}

      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_mobile)}
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_tablet)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.heading_h3_bold_desktop)}
      }

      ${theme.breakpoints.up("desktopXl")} {
        ${cssPropertiesToString(theme.typography.heading_h2_bold_desktop)}
      }
    }

    p,
    li {
      ${theme.breakpoints.up("mobile")} {
        ${cssPropertiesToString(theme.typography.paragraph_medium_medium)}
      }

      ${theme.breakpoints.up("tablet")} {
        ${cssPropertiesToString(theme.typography.paragraph_large_medium)}
      }

      ${theme.breakpoints.up("desktop")} {
        ${cssPropertiesToString(theme.typography.paragraph_xlarge_medium)}
      }
    }

    a {
      text-decoration: underline;
    }
  `,
);
